import { AdminCreateUserReq, AdminCreateUserRes, AdminDeleteUserReq, AdminDeleteUserRes, AdminGetAllUsersReq, AdminGetAllUsersRes, AdminUpdateUserReq, AdminUpdateUserRes, AdminUserChangePasswordReq, AdminUserChangePasswordRes, AESPublicReq, AESPublicRes, DisableTotpReq, DisableTotpRes, EnableTotpReq, EnableTotpRes, GenerateCaptchaReq, GenerateCaptchaRes, GenerateTotpReq, GenerateTotpRes, GetMeReq, GetMeRes, LoginReq, LoginRes, LogoutReq, LogoutRes, UserChangePasswordReq, UserChangePasswordRes, VerifyCaptchaReq, VerifyCaptchaRes } from '../interfaces/user.interface'
import {API} from './api'


export const generateCaptchaService = async (data: GenerateCaptchaReq): Promise<GenerateCaptchaRes>=>{
    try {
        const res = await API.get('/v1/auth/generate-captcha', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const verifyCaptchaService = async (data: VerifyCaptchaReq): Promise<VerifyCaptchaRes>=>{
    try {
        const res = await API.post('/v1/auth/verify-captcha', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getPublicKeyService = async (data: AESPublicReq): Promise<AESPublicRes>=>{
    try {
        const res = await API.get('/v1/auth/public-key', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const loginService = async (data: LoginReq): Promise<LoginRes>=>{
    try {
        const res = await API.post('/v1/auth/login', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const logoutService = async (data: LogoutReq): Promise<LogoutRes>=>{
    try {
        const res = await API.post('/v1/auth/logout', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getMeService = async (data: GetMeReq): Promise<GetMeRes>=>{
    try {
        const res = await API.get('/v1/user/me', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const userChangePasswordService = async (data: UserChangePasswordReq): Promise<UserChangePasswordRes>=>{
    try {
        const res = await API.post('/v1/user/change-password', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const userGenerateTotpCodeService = async (data: GenerateTotpReq): Promise<GenerateTotpRes>=>{
    try {
        const res = await API.post('/v1/user/totp/generate', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const userEnableTotpCodeService = async (data: EnableTotpReq): Promise<EnableTotpRes>=>{
    try {
        const res = await API.post('/v1/user/totp/enable', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const userDisableTotpCodeService = async (data: DisableTotpReq): Promise<DisableTotpRes>=>{
    try {
        const res = await API.post('/v1/user/totp/disable', data);
        return res.data;
    } catch (error) {
        throw error
    }
}



export const adminGetUsersService = async (data: AdminGetAllUsersReq): Promise<AdminGetAllUsersRes>=>{
    try {
        const res = await API.get('/v1/admin-user');
        return res.data;
    } catch (error) {
        throw error
    }
}

export const adminCreateUserService = async (data: AdminCreateUserReq): Promise<AdminCreateUserRes>=>{
    try {
        const res = await API.post('/v1/admin-user', data);
        return res.data;
    } catch (error) {
        throw error
    }
}


export const adminUpdateUserService = async (data: AdminUpdateUserReq): Promise<AdminUpdateUserRes>=>{
    try {
        const res = await API.put('/v1/admin-user', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const adminChangeUserPasswordService = async (data: AdminUserChangePasswordReq): Promise<AdminUserChangePasswordRes>=>{
    try {
        const res = await API.post('/v1/admin-user/change-password', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const adminDeleteUserService = async (data: AdminDeleteUserReq): Promise<AdminDeleteUserRes>=>{
    try {
        const res = await API.delete(`/v1/admin-user/${data.id}`);
        return res.data;
    } catch (error) {
        throw error
    }
}

